import { Tag } from '@chakra-ui/react';
import type React from 'react';
import Show from '@/components/Molecules/Show';

interface FaceliftTagProps extends Tag.RootProps {
  label: string;
  closable?: boolean;
  variant?: 'solid' | 'subtle' | 'outline';
  colorScheme?: string;
  onClose?: () => void;
  colorIndex?: number;
}

const FaceliftTag: React.FC<FaceliftTagProps> = ({
  label,
  closable = false,
  variant = 'subtle',
  colorScheme,
  onClose,
  tabIndex,
  colorIndex,
  ...rest
}) => {

  // Pick brand.500 or brand.600 based on index
  const brandKeys = ['600', '500', '300', '200'];
  const brandKey = brandKeys[colorIndex! % brandKeys.length];
  const computedColor = `brand.${brandKey}`;

  return (
    <Tag.Root
      variant={variant}
      colorScheme={colorScheme}
      backgroundColor={computedColor}
      p={1}
      px={2}
      borderRadius="full"
      {...rest}
    >
      <Tag.Label
        color={{ _light: 'brand.text', _dark: 'white' }}
        lineHeight={'24px'}
        fontSize={'10px'}
        fontWeight={500}
      >
        {label}
      </Tag.Label>
      <Show when={closable}>
        <Tag.EndElement>
          <Tag.CloseTrigger
            onClick={onClose}
            color={{ _light: 'brand.text', _dark: 'white' }}
          />
        </Tag.EndElement>
      </Show>
    </Tag.Root>
  );
};

export default FaceliftTag;
